import { HydrateOption } from '@core/enums';
import { Grid } from '@helpers/grid';
import withWidget from '@hoc/withWidget';
import useNearestDepot from '@hooks/useNearestDepot';
import { ReactComponent as Chevron } from '@img/icons/chevron.svg';
import { ReactComponent as Search } from '@img/icons/search.svg';
import MapSvgUrl from '@img/map-bg.svg';
import Heading from '@stories/Components/Global/Typography/Heading';
import Paragraph from '@stories/Components/Global/Typography/Paragraph';
import Map from '@stories/Widgets/Misc/Map/Map';
import React, { useEffect, useRef, useState } from 'react';
import { DepotLocatorStyles as s } from './DepotLocator.styles';
import { withMotion } from '@hoc/withMotion';
import { useInView } from '@hooks/useInView';
import { useScroll, useTransform } from 'framer-motion';
import { ThemeWrapper } from '@helpers/theme';
const DepotLocator = (props) => {
    const searchRef = useRef(null);
    const [searchTerm, setSearchTerm] = useState('');
    const { depot, searchDepots } = useNearestDepot();
    const [elementRef, inView] = useInView({ threshold: 0.25 });
    const { scrollYProgress } = useScroll({ target: elementRef, offset: ['start end', 'end start'] });
    const parallaxYValue = useTransform(scrollYProgress, [0, 1], ['-40%', '40%']);
    /** Searches depots on search change */
    useEffect(() => {
        if (searchTerm.length === 0 || !searchRef.current) {
            return;
        }
        searchDepots(searchTerm);
        searchRef.current.focus();
    }, [searchTerm]);
    return (React.createElement(ThemeWrapper, { "data-theme": props.theme },
        React.createElement(s.MotionWrapper, { "data-in-view": inView },
            React.createElement(s.Wrapper, { ref: elementRef },
                React.createElement(s.BackgroundTriangle, null),
                React.createElement(Grid.Default, null,
                    React.createElement(s.Background, { style: { y: parallaxYValue }, src: MapSvgUrl, loading: "lazy", alt: "Depot Locator Background" }),
                    React.createElement(s.ContentArea, null,
                        props.title ? (React.createElement(Heading, { semantic: "h1", visual: "h5" }, props.title)) : null,
                        props.description ? React.createElement(Paragraph, { size: "regular" }, props.description) : null,
                        props.learnMoreText && props.learnMoreUrl ? (React.createElement(s.Link, { href: props.learnMoreUrl },
                            props.learnMoreText,
                            " ",
                            React.createElement(Chevron, null))) : null,
                        React.createElement(s.SearchWrapper, null,
                            React.createElement("input", { ref: searchRef, type: "text", placeholder: props.searchPlaceholder, value: searchTerm, onChange: (e) => setSearchTerm(e.currentTarget.value) }),
                            React.createElement("button", { type: "button", "aria-label": "Search for depot", onClick: () => searchDepots(searchTerm) },
                                React.createElement(Search, null)))),
                    React.createElement(s.MapArea, null,
                        React.createElement(Map, { googleMapsApiKey: props.googleMapsApiKey, markers: searchTerm.length > 0 && depot ? [depot] : props.initialDepots, center: props.center, zoom: 6, theme: props.theme })))))));
};
export default withWidget(withMotion(DepotLocator), 'DepotLocator', {
    hydrate: HydrateOption.InView,
});
